import React, { useEffect, useState } from 'react';
import { OutletAccordion, OutletTableLoader, TextCard } from './elements';
import { SearchInput } from '../../../pages/team-accounts/components/search-input';
import config from '../../../../shared/services/config';
import { useGetOutlets, useSearcdhOutlets } from '../../../../shared/hooks/api/useOutlet';
import AuthManager from '../../../../shared/services/AuthManager';
import { Error } from '../../../../shared/components/table';

const defaultPageSize = 10

export const WebOutletsTable = ({ mid, onOutletSelect }) => {
  const [filter, setFilter] = useState({
    pageNo: 0,
    pageSize: defaultPageSize
  })
  const updateFilter = p => setFilter(s => ({ ...s, ...p }))
  const UI = config.get('uiv2', {})

  const [getOutlets, { data, isFetching, isError }] = useGetOutlets({ mid, authToken: AuthManager.getAppToken() });
  const [searchOutlets, { data: searchedData, isFetching: isSearchDataFetching, isError: isSearchError }] = useSearcdhOutlets({ mid, authToken: AuthManager.getAppToken() });

  useEffect(() => {
    if (filter.searchTerm) {
      searchOutlets(filter)
    } else {
      getOutlets(filter)
    }
  }, [filter.pageNo, filter.pageSize, filter.searchTerm])
  const outletList = (filter.searchTerm ? searchedData : data)?.data?.result || []
  const totalOutlets = (filter.searchTerm ? searchedData : data)?.data?.records || 0
  const currentPage = (filter.searchTerm ? searchedData : data)?.data?.offset || 0
  return (
    <>
      <UI.Grid cols={4} className='tw-pb-16'>
        <UI.GridItem colSpan={2} colStart={3}>
          <SearchInput
            onChange={(e) => updateFilter({ searchTerm: e.target.value, pageNo: 0 })}
            placeholder='Search Outlet or Sub-Outlet'
            isRounded
            fullWidth
          />
        </UI.GridItem>
      </UI.Grid>
      <div className='tw-flex tw-flex-col tw-gap-16'>
        {isFetching || isSearchDataFetching ? <div className='tw-flex tw-flex-col tw-gap-24'>
          <OutletTableLoader />
        </div> : (outletList.length == 0 ? (
          (isError || isSearchError ? (<Error
            actions={[
              {
                onClick: (e) => updateFilter({ searchTerm: null, pageNo: 0 }),
                size: 'medium',
                text: 'Retry',
                variant: 'PRIMARY'
              }
            ]}
            heading="Oops! Something went wrong"
            message='SERVER ERROR'
            infographicType='server-error'
          />):
          <Error
          actions={[
            {
              onClick: (e) => updateFilter({ searchTerm: null, pageNo: 0 }),
              size: 'medium',
              text: 'Reset Filters',
              variant: 'PRIMARY'
            }
          ]}
          heading="Oops! We didn't find anything"
          description='Remove the search & try again.'
          message='NO RESULT FOUND'
          infographicType='filter-search'
        />
        )
        ) : outletList.map(({ outletId, outletName, outletIdentifier, haveChild, address }) => (
          <OutletContainer
            outletId={outletId}
            outletName={outletName}
            outletIdentifier={outletIdentifier}
            haveChild={haveChild}
            address={address}
            mid={mid}
            pageSize={defaultPageSize}
            onOutletSelect={onOutletSelect}
          />
        )))}
        <UI.Pagination
          className='co-paginations-container'
          totalRows={totalOutlets}
          currentPage={currentPage + 1}
          rowsPerPage={filter.pageSize}
          onPageChange={(pageNo) => updateFilter({ pageNo: pageNo - 1 })}
          onRowsPerPageChange={(pageSize) => updateFilter({ pageSize, pageNo: 0 })}
          isLoading={isFetching || isSearchDataFetching}
          rowPerPageOptions={[
            {
              label: '10',
              value: 10,
              checked: filter.pageSize == 10
            },
            {
              label: '50',
              value: 50,
              checked: filter.pageSize == 50
            }
          ]}
        />
      </div>
    </>
  )
}


const SubOutletContainer = ({ list, haveMore, loadMore = () => { }, isFetching, onOutletSelect }) => {
  const UI = config.get('uiv2', {})

  return <>
    <UI.Grid cols={2} gap={16}>
      {list.map(({ outletId, outletName, haveChild, address }) => <TextCard text={outletName} onClick={() => {
        onOutletSelect({ outletId, outletName, haveChild, address })
      }} />)}
    </UI.Grid>
    {isFetching ? <><UI.CircularProgress label='Loading more data..' size='18px' /></> : null}
    <div className='tw-flex tw-justify-center'>
      {haveMore ? <UI.Button
        endIcon={{ type: 'down-arrow-grey' }}
        variant='LINK'
        className='tw-mt-16 tw-text-green-gray-300'
        onClick={loadMore}
      >
        View more
      </UI.Button> : null}
    </div>
  </>
}

const OutletContainer = ({ outletId, outletName, haveChild, address, mid, pageSize, onOutletSelect }) => {
  const [open, setOpen] = useState(false);
  const [pageNo, setPageNo] = useState(0);
  const [tableData, setTableData] = useState({
    list: [],
    records: 0
  })
  const [getOutlets, { isFetching }] = useGetOutlets({
    mid,
    authToken: AuthManager.getAppToken(),
    onSuccess: ({ data }) => {
      setTableData(d => ({
        list: [...d.list, ...(data?.data?.result || [])],
        records: data?.data?.records || 0,
      }))
    }
  })

  const list = tableData.list || [];
  const haveMore = tableData.records > (pageNo + 1) * pageSize
  const loadMore = () => {
    getOutlets({
      pageNo: pageNo + 1,
      pageSize,
      outletId
    })
    setPageNo(p => p + 1)
  }
  return (
    <OutletAccordion
      title={outletName}
      address={address}
      haveChild={haveChild}
      onClick={haveChild ? () => {
        if (!tableData?.list?.length) getOutlets({ pageNo, pageSize, outletId })
        setOpen(s => !s)
      } : () => onOutletSelect({ outletId, outletName, haveChild, address })}
      open={open}
      onMasterDashSelect={() => onOutletSelect({ outletId, outletName, haveChild, address })}
    >
      {haveChild ? <SubOutletContainer list={list} haveMore={haveMore} loadMore={loadMore} isFetching={isFetching} onOutletSelect={onOutletSelect} /> : null}
    </OutletAccordion>
  )
}